<template>
    <v-dialog
            v-model="dialog"
            width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    small
                    v-if="isBasket"
            >
                <v-icon class="pl-6" size="24" v-text="'info_outlined'"></v-icon>
            </v-btn>
            <div
                v-else
                v-bind="attrs"
                v-on="on"
            >
                <span class="text-underline grey--text body-2">{{ $t('commercialPolicies') }}</span>
            </div>
        </template>
        <v-card>
            <v-card-text class="subtitle-1 grey lighten-2 font-weight-bold align-center text-uppercase py-2">
                {{ $t('commercialPolicy') }} <br> {{ sellerName }}
            </v-card-text>
            <v-card-text>
                <v-row v-if="!hasPolicies">
                    <v-col cols="12" class="text-center h6 font-weight-bold pb-0">{{ $t('commercialPolicy') }} {{ $t('absent') }}</v-col>
                </v-row>
                <v-row v-if="policies.amountPolicy && policies.amountPolicy.length" dense>
                    <v-col cols="12" class="text-center h6 font-weight-bold pb-0">{{ $t('orderPrice') }}</v-col>
                    <v-col cols="12" class="px-0">
                        <v-row dense>
                            <v-col cols="4">{{ $t('sumMin').toLowerCase() }}</v-col>
                            <v-col cols="4">{{ $t('sumMax').toLowerCase() }}</v-col>
                            <v-col cols="4">{{ $t('discount').toLowerCase() }}</v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="px-0">
                        <v-row v-for="policy in policies.amountPolicy" :key="policy.id" dense :class="policy.css">
                            <v-col cols="4" class="py-0">{{ policy.minSum.toLocaleString() }}</v-col>
                            <v-col cols="4" class="py-0">{{ policy.maxSum.toLocaleString() }}</v-col>
                            <v-col cols="4" class="py-0">{{ policy.discount }}%</v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="policies.datePolicy && policies.datePolicy.length">
                    <v-col cols="12" class="text-center h6 font-weight-bold pb-0">{{ $t('delivery') }}</v-col>
                    <v-col cols="12" class="pb-0">
                        <v-row dense>
                            <v-col cols="4" class="py-0">{{ $t('dateFrom') }}</v-col>
                            <v-col cols="4" class="py-0">{{ $t('dateTo') }}</v-col>
                            <v-col cols="4" class="py-0">{{ $t('discount').toLowerCase() }}</v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                        <v-row v-for="policy in policies.datePolicy" :key="policy.id" dense :class="policy.css">
                            <v-col cols="4" class="py-0 font-italic">{{ getMinDate(policy) || '----' }}</v-col>
                            <v-col cols="4" class="py-0 font-italic">{{ getMaxDate(policy) || '----'}}</v-col>
                            <v-col cols="4" class="py-0 font-italic">{{ policy.discount }}%</v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="policies.paymentPolicy && policies.paymentPolicy.credits && policies.paymentPolicy.credits.length">
                    <v-col cols="12" class="text-center h6 font-weight-bold pb-0">{{ $t('credit') }}</v-col>
                    <v-col cols="12">
                        <v-row dense>
                            <v-col cols="4" class="py-0">{{ $t('Prepayment').toLowerCase() }}</v-col>
                            <v-col cols="4" class="py-0">{{ $t('credit').toLowerCase() }}</v-col>
                            <v-col cols="4" class="py-0">{{ $t('discount').toLowerCase() }}</v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <v-row v-for="policy in policies.paymentPolicy.credits" :key="policy.id" dense :class="policy.css">
                            <v-col cols="4" class="py-0 font-italic">{{ getCreditPrepaymentString(policy) }}</v-col>
                            <v-col cols="4" class="py-0 font-italic">{{ getCreditRestString(policy) }}</v-col>
                            <v-col cols="4" class="py-0 font-italic">{{ policy.discount }}%</v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="policies.paymentPolicy && policies.paymentPolicy.prepayment && Object.keys(policies.paymentPolicy.prepayment).length > 0">
                    <v-col cols="12" class="text-center h6 font-weight-bold pb-0">{{ $t('Prepayment') }}</v-col>
                    <v-col cols="4" class="py-0">{{ $t('Prepayment').toLowerCase() }}</v-col>
                    <v-col cols="4" class="py-0"></v-col>
                    <v-col cols="4" class="py-0">{{ $t('discount').toLowerCase() }}</v-col>
                    <v-col cols="4" :class="['h6 font-italic py-0', policies.paymentPolicy.prepayment.css]">100%</v-col>
                    <v-col cols="4" class="py-0"></v-col>
                    <v-col cols="4" :class="['h6 font-italic py-0', policies.paymentPolicy.prepayment.css]">{{ policies.paymentPolicy.prepayment.discount }}%</v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        depressed
                        class="main--yellow white--text"
                        @click="dialog = false"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import DataProvider from '../../../../app-front/mixins/OrderDataProvider';

    export default {
        name: "PoliciesDialog",
        props: {
            sellerName: {
                type: String,
                default: null
            },
            sellerId: {
                type: Number,
                default: null
            },
            productPolicies: {
                type: Object,
                default() {
                    return {}
                }
            },
            price: Number,
        },
        mixins: [DataProvider],
        data() {
            return {
                dialog: false,
                policies: {},
                typeAmount: 1,
                typeDate: 2,
                typePayment: 3,
            }
        },
        computed: {
            sellerInProcess() {
                return this.inProcessProducts.find(item => item.sellerID === this.sellerId);
            },
            orderPrice() {
                if(!this.sellerInProcess) return null;

                return this.sellerInProcess.priceWithDiscount || this.sellerInProcess.priceSummary;
            },
            isBasket() {
                return !(Object.keys(this.productPolicies).length > 0);
            },
            hasPolicies() {
                let hasPolicies = false;

                if (!this.policies) return hasPolicies;

                if (this.policies.amountPolicy && this.policies.amountPolicy.length) hasPolicies = true;
                if (this.policies.datePolicy && this.policies.datePolicy.length) hasPolicies = true;
                if (this.policies.paymentPolicy && this.policies.paymentPolicy.credits && this.policies.paymentPolicy.credits.length) hasPolicies = true;
                if (this.policies.paymentPolicy && this.policies.paymentPolicy.prepayment && this.policies.paymentPolicy.prepayment.length) hasPolicies = true;

                return hasPolicies;
            },
        },
        methods: {
            convertDate(date) {
                return date.split('-').reverse().join('.');
            },
            getMaxDate(policy) {
                if (!policy.dates || !policy.dates.length) return null;

                if(policy.dates.length === 2) return this.convertDate(policy.dates[1]);

                return this.convertDate(policy.dates[0]);
            },
            getCreditPrepaymentString(policy) {
                let str = '';

                if(policy.creditPrepayment) {
                    str += `${policy.creditPrepayment}%`;
                }

                if(policy.creditTerm) {
                    str += ` (${policy.creditTerm} дн.)`;
                }

                return str;
            },
            getCreditRestString(policy) {
                let str = '';

                if(policy.creditRest) {
                    str += `${policy.creditRest}%`;
                }

                if(policy.prepaymentTo) {
                    str += ` (до ${policy.prepaymentTo.split('-').reverse().join('.')})`;
                }

                return str;
            },

            getMinDate(policy) {
                if (!policy.dates || !policy.dates.length) return null;

                if(policy.dates.length === 2) return this.convertDate(policy.dates[0]);
            },
            setPolicies() {
                if(this.isBasket) {
                    let seller = this.orderProducts.find(item => item.seller.id === this.sellerId);
                    if(!seller || !seller.policies) {
                        return null;
                    }
                    this.policies =  seller ? this.updatePolicies(seller.policies) : null;
                } else {
                    this.policies =  this.updatePolicies(this.productPolicies);
                }
            },
            setAmountPolicy() {
                let lastIndex;
                if(this.productPolicies.amountPolicy.length > 0) {
                    this.productPolicies.amountPolicy.forEach((item, idx) => {
                        item.css = undefined;
                        if(this.price >= item.minSum && this.price <= item.maxSum) {
                            lastIndex = idx;
                        }
                    })
                    if(lastIndex != undefined) {
                        this.productPolicies.amountPolicy[lastIndex].css = 'teal--text font-weight-bold';
                    }
                }
            },
            updatePolicies(policies) {
                if(!this.sellerInProcess) return policies;

                if(policies.amountPolicy) {
                    policies.amountPolicy.forEach(item => {
                        let css = null;

                        if(this.sellerInProcess.activePolicies && this.sellerInProcess.activePolicies.amount && this.sellerInProcess.activePolicies.amount.length) {
                            css = this.sellerInProcess.activePolicies.amount.indexOf(item.id) < 0 ? '' : 'teal--text';
                        }


                        item['css'] = css;
                    })
                }

                if(policies.datePolicy) {
                    policies.datePolicy.forEach(item => {
                        let css = null;

                        if(this.sellerInProcess.activePolicies && this.sellerInProcess.activePolicies.dates && this.sellerInProcess.activePolicies.dates.length) {
                            css = this.sellerInProcess.activePolicies.dates.indexOf(item.id) < 0 ? '' : 'teal--text';
                        }

                        item['css'] = css;
                    })
                }

                if(policies.paymentPolicy.prepayment && policies.paymentPolicy.prepayment.discount) {
                    let css = null;

                    if(this.sellerInProcess.activePolicies && this.sellerInProcess.activePolicies.prepayment && this.sellerInProcess.activePolicies.prepayment.length) {
                        css = this.sellerInProcess.activePolicies.prepayment.indexOf(policies.paymentPolicy.prepayment.id) < 0 ? '' : 'teal--text';
                    }

                    policies.paymentPolicy.prepayment['css'] = css;
                }

                if(policies.paymentPolicy && policies.paymentPolicy.credits) {
                    policies.paymentPolicy.credits.forEach(item => {
                        let css = null;

                        if(this.sellerInProcess.activePolicies && this.sellerInProcess.activePolicies.credit && this.sellerInProcess.activePolicies.credit.length) {
                            css = this.sellerInProcess.activePolicies.credit.indexOf(item.id) < 0 ? '' : 'teal--text';
                        }

                        item['css'] = css;
                    })
                }

                return policies;
            }
        },
        created() {
            if(this.price > 0){
                this.setAmountPolicy()
            }
            this.setPolicies();
        },
        watch: {
            orderPrice() {
                this.setPolicies();
            },
            price() {
                this.setAmountPolicy()
            }
        }
    }
</script>
